import { render } from "./WebhookHistoryModal.vue?vue&type=template&id=f137bcf8&ts=true"
import script from "./WebhookHistoryModal.vue?vue&type=script&lang=ts"
export * from "./WebhookHistoryModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__